var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('edit-profile-form',{attrs:{"model":_vm.model}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }